<template>
  <div>
    <div class="layer-header">
      <h1 class="header-title">상담 규정 및 상담 시 유의사항(필수)</h1>
    </div>
    <div class="layer-content">
      <div class="terms_content">
        <h3>상담</h3>
        <ul>
          <li>약 15~20분간 상담을 진행합니다.</li>
          <li>마이팩 주문을 완료한 ABO만 상담이 가능합니다.</li>
          <li>
            본인 외 섭취자를 위해 대리 상담을 진행하는 경우, 섭취 본인에게 대리
            상담에 관하여 충분한 설명과, 정보 수집에 대한 동의를 받고 진행하시기
            바랍니다.
          </li>
        </ul>
        <h3>상담 시 유의사항</h3>
        <ul>
          <li>
            상담 진행 시, 간단한 본인 확인 절차가 진행되며, 해당 내용이
            기록됩니다. 기록된 상담 내용은 일정 기간 보관되며, 정부 요청에 의한
            제출 외에 다른 용도로는 사용되지 않습니다. 해당 기록 진행에 동의하지
            않는 경우 상담은 불가합니다.
          </li>
          <li>
            상담 이용 시 개인정보보호법에 따른 개인정보동의가 필요합니다. 별도의
            제공되는 개인정보동의서를 확인하여 주시기 바랍니다.
          </li>
          <li>
            채팅 상담 시 상담 내용 및 관련 기록은 저작권법상 보호를 받습니다.
            따라서 어떠한 형태의 스크린 캡처, 복제, 재전송을 금지하며, 관련 해설
            및 설명도 배포할 수 없습니다.
          </li>
          <li>
            당사는 산업안전보건법에 따라 고객응대 근로자 보호조치를 시행하고
            있습니다. 폭언, 욕설 시에는 상담이 종료될 수 있고, 상습적인 폭언
            욕설 시 이용이 제한되며, 형사 처벌의 대상이 될 수 있습니다.
          </li>
          <li>
            채팅 상담 시 상담 내용이 유출되지 않도록 주의하시기 바랍니다. 개방된
            공간, 기기 등을 이용해 상담을 받음으로 인하여 발생할 수 있는 각종
            권리 침해 또는 손해에 대한 책임은 본인에게 있습니다.
          </li>
          <li>
            성폭력범죄의 처벌 등에 관한 특례법에 따라 본 상담 시 성적 수치심이나
            혐오감을 일으키는 말, 음향, 글, 그림, 영상 또는 물건을 상대방에게
            도달하도록 하는 행위는 형사 처벌의 대상이 될 수 있습니다.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TermConsultation",
};
</script>
